import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { StickyCallBar } from "@/components/StickyCallBar";
import { CookieConsent } from "@/components/CookieConsent";

export const Layout = ({ children }) => (
  <div className="App flex flex-col min-h-screen">
    <Header />
    <main className="flex-1 pb-16 lg:pb-0">{children}</main>
    <Footer />
    <StickyCallBar />
    <CookieConsent />
  </div>
);
